import React from 'react';
import { PageHero } from '../components/PageHero';
import { SquareCard } from '../components/SquareCard';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { PartnerCTA } from '../components/PartnerCTA';
export function AboutHubPage() {
  const sections = [{
    title: 'Who We Are',
    desc: 'Meet our leadership team and learn about our history and values.',
    to: '/about/who-we-are'
  }, {
    title: 'What We Do',
    desc: 'Our core operations, global reach, and manufacturing expertise.',
    to: '/about/what-we-do'
  }, {
    title: 'Certifications',
    desc: 'Our accreditations, standards, and compliance credentials.',
    to: '/about/certifications'
  }, {
    title: 'News & Insights',
    desc: 'Latest updates, press releases, and industry insights.',
    to: '/about/news'
  }];
  return <>
      <PageHero label="About Us" title="Our Company" subtitle="Chiltern Global is a specialist manufacturing partner for defence, police, and public sector organisations worldwide." data-id="element-375" />
      <Breadcrumbs items={[{
      label: 'About Us'
    }]} data-id="element-376" />

      <section className="bg-white py-24" data-id="element-377">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-378">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-379">
            {sections.map(section => <SquareCard key={section.to} to={section.to} title={section.title} description={section.desc} variant="category" actionText="Read More" data-id="element-380" />)}
          </div>
        </div>
      </section>

      <PartnerCTA data-id="element-381" />
    </>;
}